import { render } from "./authen.vue?vue&type=template&id=0fc00c98&scoped=true"
import script from "./authen.vue?vue&type=script&lang=js"
export * from "./authen.vue?vue&type=script&lang=js"

import "./authen.vue?vue&type=style&index=0&id=0fc00c98&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc00c98"]])

export default __exports__